import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SingleDatePickerModule } from 'NewAngular/features/components/date-controls/single-date-picker/single-date-picker.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { LoadingModalModule } from 'NewAngular/features/components/modals/loading-modal/loading-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { PortfolioOptimizerExportPDFModalModule } from 'PortfolioOptimizerApp/apps/portfolio-optimizer-app/components/portfolio-optimizer-export-pdf-modal/portfolio-optimizer-export-pdf-modal.module';
import { CorrelationMatrixHeatmapModule } from 'PortfolioOptimizerApp/features/correlation-matrix-heatmap/correlation-matrix-heatmap.module';
import { ComparablesModalModule } from 'SecuritiesApp/ts/features/comparables-modal/comparables-modal.module';
import { EditHoldingsModalModule } from 'SecuritiesApp/ts/features/edit-holdings-modal/edit-holdings-modal.module';
import { ModuleUpsellModule } from 'SecuritiesApp/ts/features/module-upsell/module-upsell.module';
import * as i0 from "@angular/core";
export class CorrelationMatrixPageModule {
}
CorrelationMatrixPageModule.ɵfac = function CorrelationMatrixPageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CorrelationMatrixPageModule)(); };
CorrelationMatrixPageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CorrelationMatrixPageModule });
CorrelationMatrixPageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ComparablesModalModule,
        CorrelationMatrixHeatmapModule,
        EditHoldingsModalModule,
        FormsModule,
        IconModule,
        LoadingModalModule,
        ModuleUpsellModule,
        PortfolioOptimizerExportPDFModalModule,
        SingleDatePickerModule,
        SingleSelectDropdownModule] });
